import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { RESOURCES } from '../../services/resources';
import { API_PREFIX } from '../../utils/injection-tokens';
import { Organization, OrganizationResponse, OrganizationsResponse } from './model';

@Injectable({ providedIn: 'root' })
export class OrganizationsService {
  API_PREFIX = inject(API_PREFIX);
  http = inject(HttpClient);

  getOrganizations(): Observable<Organization[]> {
    const url = `${this.API_PREFIX}${RESOURCES.ORGANIZATIONS.organizations}`;

    return this.http
      .get<OrganizationsResponse>(url)
      .pipe(map(response => response.organizations.map(org => this.mapOrganization(org))));
  }

  changeOrganizationName(organizationId: string, name: string) {
    const url = `${this.API_PREFIX}${RESOURCES.ORGANIZATIONS.organization(organizationId)}`;

    const body = {
      name,
    };
    return this.http.patch<{ name: string }>(url, body);
  }

  createOrganization(name: string, isInternal: boolean): Observable<Organization> {
    const url = `${this.API_PREFIX}${RESOURCES.ORGANIZATIONS.organizations}`;

    const body = {
      name,
      is_internal: isInternal,
    };

    return this.http.post<OrganizationResponse>(url, body).pipe(map(org => this.mapOrganization(org)));
  }

  private mapOrganization(org: OrganizationResponse): Organization {
    return {
      members: org.members_count,
      id: org.id,
      name: org.name,
      isInternal: org.is_internal,
      allowedModels: org?.allowed_models?.map(model => ({
        name: model.name,
        temperatureRange: {
          min: model.temperature_range?.min,
          max: model.temperature_range?.max,
          default: Math.floor(model.temperature_range?.default * 10) / 10, // to convert 0.75 to 0.7
        },
        supportedFormats: model.supported_formats,
        descriptionDe: model.description_de,
        descriptionEn: model.description_en,
        isDefault: model.is_default,
        expired: model.expired,
      })),
    };
  }
}
